import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import SelfCareBannerBlockData from "../../../Models/Content/SelfCareBannerBlockData";
import SelfCareBanner from "./SelfCareBanner";

export default class SelfCareBannerBlock extends EpiComponent<SelfCareBannerBlockData> {

  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = [""];
    return (
        <SelfCareBanner context={this.getContext()} data={this.props.data} />
    );
  }
}
